const escapeHtml = (text) =>
    text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Parses stored content into Editor.js data. Legacy plain-text posts become one paragraph per line.
export const toEditorData = (content) => {
    if (!content) return { blocks: [] };

    try {
        const parsed = JSON.parse(content);
        if (parsed && Array.isArray(parsed.blocks)) return parsed;
    } catch {
        // legacy plain text
    }

    return {
        blocks: content
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean)
            .map(line => ({ type: 'paragraph', data: { text: escapeHtml(line) } })),
    };
};
